import { v4 as uuid } from 'uuid';
import React, { memo } from 'react';
import {
  CarnetElevesSort,
  Evaluation,
  Note,
} from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';
import { Eleve } from '@teetsh/app/src/types/eleves';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { PlusCircleIcon as PlusCircle } from '@heroicons/react/20/solid';
import { Notes } from './Notes';
import { useTranslation } from 'react-i18next';
import { useCDNContext } from '@teetsh/app/src/containers/CarnetsDeNotes/CarnetDeNotesContext';

interface Props {
  evaluation: Evaluation;
  eleves: Eleve[];
  onReplaceNotes: (notes: Note[]) => void;
  elevesSort: CarnetElevesSort;
  onUpdateSort: (sort: CarnetElevesSort) => void;
}

export function NotesRoot(props: Props) {
  const { eleves, evaluation, onReplaceNotes } = props;
  const { t } = useTranslation(['carnet']);
  const { notationSystem } = useCDNContext();

  if (evaluation.notes.length === 0) {
    return (
      <Button
        fill
        large
        extralarge
        minimal
        onClick={() =>
          onReplaceNotes(
            eleves.map(eleve => ({
              id: uuid(),
              evaluationId: evaluation.id,
              note: 0,
              eleveId: eleve.id,
              eleve: eleve,
              notationSystemId: notationSystem.id,
              notationSystemMin: notationSystem.minValue,
              notationSystemMax: notationSystem.maxValue,
            })),
          )
        }
        icon={PlusCircle}
      >
        {t('carnet:addEvaluationGrades')}
      </Button>
    );
  }
  return (
    <Notes
      elevesSort={props.elevesSort}
      onUpdateSort={props.onUpdateSort}
      onReplaceNotes={onReplaceNotes}
      eleves={eleves}
      evaluation={evaluation}
    />
  );
}

function propsAreEqual(prev: Props, next: Props) {
  const sameNotes =
    JSON.stringify(prev.evaluation.notes) ===
    JSON.stringify(next.evaluation.notes);
  const sameEval = prev.evaluation.id === next.evaluation.id;
  const sameReferential =
    JSON.stringify(prev.evaluation.referential) ===
    JSON.stringify(next.evaluation.referential);
  const sameEleves =
    prev.eleves.map(ev => ev.id).join('') ===
    next.eleves.map(ev => ev.id).join('');
  const sameOnReplaceNotes = prev.onReplaceNotes === next.onReplaceNotes;
  const sameSort =
    JSON.stringify(prev.elevesSort) === JSON.stringify(next.elevesSort);
  const sameOnUpdateSort = prev.onUpdateSort === next.onUpdateSort;
  return (
    sameEleves &&
    sameOnReplaceNotes &&
    sameEval &&
    sameReferential &&
    sameNotes &&
    sameSort &&
    sameOnUpdateSort
  );
}

export default memo(NotesRoot, propsAreEqual);
